t = require('app/scripts/views/internal/teacup-with-helpers')('crop_photo')

module.exports = ->
  t.img '.crop-image'
  t.button '.primary.js-done', ->
    t.format 'looks-good'
  t.button '.js-back', ->
    t.format 'try-again-ellipsis'
